$ = require('jquery')

GroupInformationCtrl = ($scope ,$filter ,$location ,groupInfo ,userInfo ,groupStatus ,$ngConfirm ,groupDetailToolbarService ) ->
  angular.element(document.body).css 'min-width', 0

  $(document).ready( ->
    document.body.scrollTop = document.documentElement.scrollTop = 0
  )

  $scope.groupInfo = groupInfo
  $scope.userInfo = userInfo
  $scope.groupStatus = groupStatus

  $scope.leaveGroup = ->
    params =
      user_id : userInfo.user_id
      group_id : groupInfo.id
    mess = $filter('translate')('_GROUP.TOOLBAR.CONFIRM_MESS_LEAVE_GROUP')
    errorMess = $filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: ->
            groupDetailToolbarService.leaveGroup(params)
              .then (resp) ->
                $location.path('/groups')
              .catch (resp) ->
                $ngConfirm(errorMess)
    $ngConfirm(config)

GroupInformationCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  'groupInfo'
  'userInfo'
  'groupStatus'
  '$ngConfirm'
  'groupDetailToolbarService'
]

module.exports = GroupInformationCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-information-controller.coffee